import {getScrollbarWidth} from '../util/helperFunctions';

window.addEventListener('load', () => {
	if (document.querySelectorAll('.booking-types [data-bs-toggle="modal"]')) {
		const scrollbarWidth = getScrollbarWidth();
		const siteHeader = document.getElementById('site-header');
		const adminbar = document.getElementById('wpadminbar');
		const modals = document.querySelectorAll('.modal-booking-type');

		modals.forEach(function (modalEl) {
			const modal = modalEl;

			modal.addEventListener('show.bs.modal', () => {
				if (siteHeader) {
					siteHeader.style.right = scrollbarWidth + 'px';
				}

				if (adminbar) {
					adminbar.style.right = scrollbarWidth + 'px';
					adminbar.style.width = 'auto';
				}
			});

			modal.addEventListener('hidden.bs.modal', () => {
				if (siteHeader) {
					siteHeader.style.right = '';
				}

				if (adminbar) {
					adminbar.style.right = '';
					adminbar.style.width = '';
				}
			});
		});
	}
});
